<template>
	<div :class="{'online': instance && cloudstreamer_ready}" v-if="is_visible">
    <v-layout row fluid style="min-height: 50px; line-height: 50px;">
      <v-flex xs1 style="min-width: 60px; max-width: 60px;">
        <template v-if="is_cloudstreamer && !instance">
          <v-btn fab small color="green" v-on:click.stop="start_cloudstreamer" :disabled="!can_start()"><v-icon>power_settings_new</v-icon></v-btn>
        </template>
        <template v-if="is_cloudstreamer && instance">
          <v-btn fab small color="red" v-on:click.stop="stop_cloudstreamer" :disabled="!can_start()">
            <template v-if="!cloudstreamer_ready">
              <v-progress-circular :value="20" :indeterminate="true" size="18"></v-progress-circular>
            </template>
            <template v-else>
              <v-icon>power_settings_new</v-icon>
           </template>
          </v-btn>
        </template>
      </v-flex>
      <v-flex xs11>
        <div>{{channel_title}}</div>
      </v-flex>
    </v-layout>
    <v-layout row fluid>
      <v-flex xs12>
        <template v-if="is_cloudstreamer && instance && cloudstreamer_ready && https_port">
          <v-btn v-if="is_access(['director'])" color="blue" v-on:click="open_gui()">GUI</v-btn>
          <v-btn v-if="is_access(['director','commentator'])" color="blue" v-on:click="open_view('webrtc-ext1')">Commentator 1</v-btn>
          <v-btn v-if="is_access(['director','commentator'])" color="blue" v-on:click="open_view('webrtc-ext2')">Commentator 2</v-btn>
          <v-btn v-if="is_access(['director','intercom','commentator'])" color="blue" v-on:click="open_intercom('intercom')">Intercom</v-btn>

          <template v-for="output in webrtc_outputs">
            <v-btn v-if="is_access(['director','producer'])" color="blue" v-on:click="open_webrtc(output, false)">{{output.title}}</v-btn>
          </template>

        </template>
        <template v-if="is_output && instance">
          <template v-for="output in webrtc_outputs">
            <v-btn color="blue" v-on:click="open_webrtc(output, true)">{{output.title}}</v-btn>
          </template>
        </template>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>

  </div>
</template>

<script>
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

import webrtc from '@/lib/webrtc_reader.js'

export default {
  props: ["channel_id"],

  data () {
    var ch = this.$cloudserver.channel("channels:"+this.channel_id);
    return {
      ws_channel: ch,
      channel: ch.data,
      timestamp: undefined,
      updater: undefined,
      instance: undefined,
      cloudstreamer_ready: false,
      channel_title: "",
      instance_title: "",
      is_cloudstreamer: false,
      is_output: false,
      cloudstreamer_starting: false,
      video_open: false,
      video_name: undefined,
      webrtc_reader: undefined,
      https_port: undefined,
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel = newVal;
        }
      },
      deep: true
    }
  },
  mounted () {
    this.ws_channel.join();
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  beforeDestroy () {
    if (typeof(this.updater) != "undefined") {
      clearTimeout(this.updater);
    }
  },
  methods: {
    is_ios() {
      return (/iPad|iPhone|iPod/.test(navigator.platform) ||(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream
    },
    can_start() {
      return this.is_access(["director"]);
    },
    open_webrtc(output, is_control) {
      this.open_window("#/productions/" + this.channel_id + "/view/" + output.name + "?view=popup&control=" + is_control, "webrtc-" + this.channel_id + "-" + output.webrtc_name, "width=1280, height=720");
    },
    is_access(role) {
      if (this.$is_admin()) return true;
      if (Array.isArray(role)) {
        var ret = false;
        _.each(role, (r) => {
          if (this.is_access(r) == true) ret = true;
        })
        return ret;
      }
      var self = this;
      var groups = this.$store.getters.groups;
      var account = this.$store.state.account;
      if (typeof(account) == "undefined") return false;
      if (typeof(groups) == "undefined") return false;

      var channel_uuid = self.channel.uuid;
      var ret = false;
      _.each(groups, (group) => {
        var channels = group.channels;
        if (channels.includes(channel_uuid)) {
          var production_role = _.get(group, ["meta", "production_roles", account.id]);
          if (role == production_role) ret = true;
        }
      });
      return ret;
    },
    timestamp_update() {
      this.instance = ChannelModel.instance(this.channel);
      this.channel_title = ChannelModel.title(this.channel);
      this.instance_title = InstanceModel.title(this.instance);
      this.is_cloudstreamer = ChannelModel.is_cloudstreamer(this.channel);
      this.https_port = _.get(this.channel, ["configuration", "streamer","config","proxy_port"]) || 
        _.get(this.channel, ["configuration", "streamer", "config", "https_port"]) || 
        _.get(this.instance, ["meta", "https_port"]) || "8070";

      this.is_output = (ChannelModel.get_type(this.channel) == "output");
      this.webrtc_outputs = _.get(this.channel, ["configuration", "streamer", "config", "webrtc_outputs"]);

      if (ChannelModel.is_cloudstreamer(this.channel) && this.instance && this.instance.system_info?.ip && this.cloudstreamer_ready == false) {
        this.check_cloudstreamer();
      }
    },
    open_window(url, name, opts) {
      if (this.is_ios()) {
        document.location.href = url;
      } else {
        window.open(url, name, opts);
      }
    },
    open_gui() {
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url, "new-window-gui", "width=1920, height=1080");
      }
    },
    open_view(type) {
      var mod_name = "output0";
      var view = "webrtc-view";
      if (type == "pgm") {
        mod_name = "output0";
      }
      if (type == "preview") {
        mod_name = "output1";
      }
      if (type == "multiview") {
        mod_name = "output2";
      }
      if (type == "webrtc-ext1") {
        view = "index";
        mod_name = "webrtc-ext1";
      }
      if (type == "webrtc-ext2") {
        view = "index";
        mod_name = "webrtc-ext2";
      }
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url + "m/"+mod_name+"/"+view+".html", "new-window-"+mod_name, "width=1920, height=1080");
      }
    },
    open_intercom(role) {
      var url = InstanceModel.studio_url(this.instance, this.https_port);
      if (url != "") {
        this.open_window(url + "modules/intercom/users.html?role="+role, "new-window-intercom", "width=1000, height=1080");
      }
    },
    start_cloudstreamer () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "input") {
        if (self.cloudstreamer_starting == true) return;
        self.cloudstreamer_starting = true;
        ChannelModel.start_transcoder(ch, (msg) => {
          self.$message.success("Streamer started!");
          self.cloudstreamer_starting = true;
          self.timestamp_update();
        }, (err) => {
          self.cloudstreamer_starting = false;
          self.$message.success("Streamer start failed!" + JSON.stringify(msg));
          self.timestamp_update();
        });
      }
    },
    stop_cloudstreamer () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "input") {
        var instance = ChannelModel.instance(this.channel);
        InstanceModel.stop_transcoder(instance, (msg) => {
          self.$message.success("Streamer stopped");
          self.cloudstreamer_starting = false;
          self.cloudstreamer_ready = false;
          self.timestamp_update();
        }, (err) => {
          this.cloudstreamer_ready = false;
          self.$message.success("Streamer stop failed!" + JSON.stringify(err));
          self.timestamp_update();
        });
      }
    },
    check_cloudstreamer () {
      var self = this;
      if (this.instance && this.instance.system_info.ip) {
        console.log("Checking cloudstreamer ready");
        var gui_url = InstanceModel.studio_url(this.instance, this.https_port);
        if (gui_url != "") {
          self.$http.get(gui_url + "static/test.html").then((response) => {
            self.cloudstreamer_ready = true;
            return;
          }).catch((err) => {
            console.log("Error response ",err);
          });
        }
      }
    },
  },
  computed: {
    is_visible() {
      if (ChannelModel.is_cloudstreamer(this.channel)) return true;
      if (ChannelModel.get_type(this.channel) == "output" && ChannelModel.is_transcoder(this.channel) == false) {
        if (_.get(this.channel, ["configuration", "streamer", "config", "webrtc_outputs"])) return true;
      }
      return false;
    }
  }
}
</script>

<style scoped>
  .online {
    background-color: rgba(0,255,0,0.2);
  }
  .ctrl {
    margin-right: 10px !important;  
  }
</style>